module.exports = __webpack_public_path__ + "img/badge-list-thumb-165.de0b3445.png";